module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_save-o-583ce26fcbd006d010f6c03e398a7d95.svg";